import React from 'react';
import { motion } from 'framer-motion';
import { Check, Minus, Clock, ShieldAlert } from 'lucide-react';
export function PricingSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const features = [{
    name: 'Resumen ejecutivo automático',
    od: true,
    wa: false
  }, {
    name: 'Reporte PDF semanal',
    od: true,
    wa: false
  }, {
    name: 'Mensajes clasificados por categoría',
    od: true,
    wa: false
  }, {
    name: 'Búsqueda full-text en todo el chat',
    od: true,
    wa: false
  }, {
    name: 'Unificación de aliases (mismo contacto, distintos nombres)',
    od: true,
    wa: false
  }, {
    name: 'Acceso por roles (mandante, ITO, constructora)',
    od: true,
    wa: false
  }, {
    name: 'Fotos ordenadas por obra y fecha',
    od: true,
    wa: false
  }, {
    name: 'Historial permanente online',
    od: true,
    wa: false
  }, {
    name: 'Sin capacitación ni apps nuevas',
    od: true,
    wa: true
  }];
  return <section id="precio" className="py-14 sm:py-20 bg-gray-50" data-id="element-197">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <div className="text-center mb-12 sm:mb-16" data-id="element-199">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-200">
            Precio fijo por obra. Sabes lo que pagas antes de empezar.
          </h2>
          <p className="text-lg text-gray-600" data-id="element-201">
            Sin sorpresas. Sin costos ocultos por usuario.
          </p>
        </div>

        {/* Tiers */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 mb-16 items-stretch" data-id="element-202">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm text-center flex flex-col" data-id="element-203">
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-204">Free</h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-205">
              Para probar el producto
            </p>
            <div className="text-3xl font-extrabold text-gray-900 mb-1" data-id="element-206">$0</div>
            <p className="text-xs text-gray-400" data-id="element-207">para siempre</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm text-center flex flex-col" data-id="element-208">
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-209">Obra Chica</h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-210">Hasta 1.000 m²</p>
            <div className="text-3xl font-extrabold text-blue-600 mb-1" data-id="element-211">
              UF 5
            </div>
            <p className="text-xs text-gray-400" data-id="element-212">al mes</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-blue-600 rounded-2xl p-6 border border-blue-700 shadow-md text-center flex flex-col" data-id="element-213">
            <h3 className="text-lg font-bold text-white mb-1" data-id="element-214">Obra Mediana</h3>
            <p className="text-sm text-blue-100 mb-4" data-id="element-215">Hasta 5.000 m²</p>
            <div className="text-3xl font-extrabold text-white mb-1" data-id="element-216">UF 15</div>
            <p className="text-xs text-blue-200" data-id="element-217">al mes</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm text-center flex flex-col" data-id="element-218">
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-219">
              Obra Grande
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-220">Más de 5.000 m²</p>
            <div className="text-3xl font-extrabold text-blue-600 mb-1" data-id="element-221">
              UF 30
            </div>
            <p className="text-xs text-gray-400" data-id="element-222">al mes</p>
          </motion.div>
        </div>

        <p className="text-center text-sm text-gray-600 font-medium -mt-10 mb-12" data-id="element-223">
          Planes pagados:{' '}
          <span className="text-gray-900 font-semibold" data-id="element-224">
            sin límite de usuarios, mensajes o fotos.
          </span>
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-225">
          {/* Column Headers */}
          <div className="grid grid-cols-[1fr_88px_88px] sm:grid-cols-[1fr_120px_120px] bg-gray-50 border-b border-gray-200 p-4" data-id="element-226">
            <div className="font-bold text-gray-900 text-sm sm:text-base flex items-center" data-id="element-227">
              Comparativa
            </div>
            <div className="text-center" data-id="element-228">
              <div className="text-[11px] sm:text-xs font-bold text-blue-600 mb-0.5" data-id="element-229">
                Obra Digital
              </div>
            </div>
            <div className="text-center" data-id="element-230">
              <div className="text-[11px] sm:text-xs font-bold text-gray-500 mb-0.5" data-id="element-231">
                WhatsApp Solo
              </div>
            </div>
          </div>

          {/* Feature Rows */}
          <div className="px-4" data-id="element-232">
            {features.map((feature, index) => <div key={index} className={`grid grid-cols-[1fr_88px_88px] sm:grid-cols-[1fr_120px_120px] items-center py-3.5 ${index < features.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-233">
                <span className="text-[13px] sm:text-sm text-gray-700 font-medium pr-4" data-id="element-234">
                  {feature.name}
                </span>
                <div className="flex justify-center" data-id="element-235">
                  {feature.od ? <Check className="w-5 h-5 text-blue-600" strokeWidth={2.5} data-id="element-236" /> : <Minus className="w-5 h-5 text-gray-300" strokeWidth={2} data-id="element-237" />}
                </div>
                <div className="flex justify-center" data-id="element-238">
                  {feature.wa ? <Check className="w-5 h-5 text-gray-400" strokeWidth={2.5} data-id="element-239" /> : <Minus className="w-5 h-5 text-gray-300" strokeWidth={2} data-id="element-240" />}
                </div>
              </div>)}
          </div>

          {/* CTA */}
          <div className="p-6 bg-gray-50 border-t border-gray-200" data-id="element-241">
            <button onClick={scrollToContact} className="w-full py-3.5 px-6 rounded-xl text-base font-bold text-white bg-blue-600 hover:bg-blue-700 transition-colors shadow-sm" data-id="element-242">
              Probar en mi obra
            </button>
          </div>
        </motion.div>

        {/* Value arguments */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-10 space-y-3 max-w-2xl mx-auto" data-id="element-243">
          <div className="flex items-center justify-between py-3.5 px-5 rounded-xl bg-white border border-gray-200 shadow-sm" data-id="element-244">
            <div className="flex items-center text-gray-700 font-medium text-sm" data-id="element-245">
              <Clock className="w-4 h-4 mr-2.5 text-gray-400" data-id="element-246" />2 horas a la
              semana armando el reporte
            </div>
            <span className="text-blue-600 font-bold text-sm text-right ml-2" data-id="element-247">
              = más caro que el sistema completo
            </span>
          </div>
          <div className="flex items-center justify-between py-3.5 px-5 rounded-xl bg-white border border-gray-200 shadow-sm" data-id="element-248">
            <div className="flex items-center text-gray-700 font-medium text-sm" data-id="element-249">
              <ShieldAlert className="w-4 h-4 mr-2.5 text-gray-400" data-id="element-250" />
              Una decisión perdida
            </div>
            <span className="text-blue-600 font-bold text-sm text-right ml-2" data-id="element-251">
              = más cara que un año de Obra Digital
            </span>
          </div>
          <p className="text-xs text-gray-400 text-center pt-3 font-medium" data-id="element-252">
            Menos del 0,1% del presupuesto total de una obra promedio.
          </p>
        </motion.div>
      </div>
    </section>;
}